import React, { forwardRef, InputHTMLAttributes } from 'react';
import { FieldLabel } from './FieldLabel';


export type TextInputProps = {
    label?: string;
    containerClassName?: string;
} & InputHTMLAttributes<HTMLInputElement>;


export const TextInput = forwardRef<HTMLInputElement, TextInputProps>(function TextInput(
    { label, containerClassName, className, ...rest },
    ref
) {
    return (
        <label className={['block space-y-2', containerClassName].filter(Boolean).join(' ')}>
            {label && <FieldLabel>{label}</FieldLabel>}
            <input
                ref={ref}
                className={[
                    'w-full rounded-xl border border-white/10 bg-white/5 px-4 py-3 text-white font-montserrat placeholder:text-slate-500',
                    'focus:outline-none focus:ring-2 focus:ring-[#ff8a4a]/60 focus:border-[#ff8a4a]/60 transition-all',
                    className || ''
                ].join(' ')}
                {...rest}
            />
        </label>
    );
});